interface Config {
  mode: string;
  supportPortalServiceUrl: string;
  themeLocation: string;
  prebuiltFormLocation: string;
  prebuiltSurveyLocation: string;
  publicAPIAccessKey: string;
  recordingsLocationId: string;
  recordingsCompanyId: string;
}

const config: { [key: string]: Config } = {
  development: {
    mode: "dev",
    supportPortalServiceUrl:
      "https://staging.services.leadconnectorhq.com/support-portal",
    publicAPIAccessKey: "rI^jjSUiPmT&iUjaQZMhhCSwS1ZW#Hx4WOnA!T06byAotj3gmN",
    themeLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltFormLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltSurveyLocation: "asz1tSzagkgOeSbKfxnE",
    recordingsLocationId: "NitqzK9VGOtSNCQPgHjF",
    recordingsCompanyId: "5DP4iH6HLkQsiKESj6rh",
  },
  staging: {
    mode: "staging",
    supportPortalServiceUrl:
      "https://staging.services.leadconnectorhq.com/support-portal",
    publicAPIAccessKey: "rI^jjSUiPmT&iUjaQZMhhCSwS1ZW#Hx4WOnA!T06byAotj3gmN",
    themeLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltFormLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltSurveyLocation: "asz1tSzagkgOeSbKfxnE",
    recordingsLocationId: "NitqzK9VGOtSNCQPgHjF",
    recordingsCompanyId: "5DP4iH6HLkQsiKESj6rh",
  },
  interop: {
    mode: "interop",
    supportPortalServiceUrl:
      "https://interop.services.leadconnectorhq.com/support-portal",
    publicAPIAccessKey: "rI^jjSUiPmT&iUjaQZMhhCSwS1ZW#Hx4WOnA!T06byAotj3gmN",
    themeLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltFormLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltSurveyLocation: "asz1tSzagkgOeSbKfxnE",
    recordingsLocationId: "NitqzK9VGOtSNCQPgHjF",
    recordingsCompanyId: "5DP4iH6HLkQsiKESj6rh",
  },
  beta: {
    mode: "beta",
    supportPortalServiceUrl:
      "https://beta.services.leadconnectorhq.com/support-portal",
    publicAPIAccessKey: "rI^jjSUiPmT&iUjaQZMhhCSwS1ZW#Hx4WOnA!T06byAotj3gmN",
    themeLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltFormLocation: "asz1tSzagkgOeSbKfxnE",
    prebuiltSurveyLocation: "asz1tSzagkgOeSbKfxnE",
    recordingsLocationId: "NitqzK9VGOtSNCQPgHjF",
    recordingsCompanyId: "5DP4iH6HLkQsiKESj6rh",
  },
  production: {
    mode: "production",
    supportPortalServiceUrl:
      "https://services.leadconnectorhq.com/support-portal",
    publicAPIAccessKey: "rI^jjSUiPmT&iUjaQZMhhCSwS1ZW#Hx4WOnA!T06byAotj3gmN",
    themeLocation: "kEobaX8jxsi51wEeNyfE",
    prebuiltFormLocation: "D3ZZB4xxpRJaZLZUMcoB",
    prebuiltSurveyLocation: "D3ZZB4xxpRJaZLZUMcoB",
    recordingsLocationId: "t4fGOGY8tBpQcYe6jPLE",
    recordingsCompanyId: "ktapXmiRvMM4pJHyN3b3",
  },
};

// local overrides
// config.development = {
//   ...config.development,
//   supportPortalServiceUrl: "http://localhost:8383/support-portal",
// };

// versioned ovverides
// config.staging = {
//   ...config.staging,
//   supportPortalServiceUrl:
//     "https://staging.versionedservices.leadconnectorhq.com/support-portal",
// };

export default config[process.env.NODE_ENV];
